import { render, staticRenderFns } from "./ProjectProjects.vue?vue&type=template&id=144e05bc&scoped=true"
import script from "./ProjectProjects.vue?vue&type=script&lang=ts"
export * from "./ProjectProjects.vue?vue&type=script&lang=ts"
import style0 from "./ProjectProjects.vue?vue&type=style&index=0&id=144e05bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144e05bc",
  null
  
)

export default component.exports